import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { useHistory } from 'react-router-dom'
import { CoreButton } from 'src/components/core'

const CommunityFreeAccountModal = props => {
  const { classes } = props
  const history = useHistory()

  const handleClickRedirect = () => {
    history.push('/pricing')
  }

  return (
    <div className={classes.content}>
      <Typography className={classes.header}>
        Bring Your Course to Life with Social Learning
      </Typography>
      <Typography className={classes.text}>
        Learners can share reflections, post ideas, give testimonials, and
        interact with each other inside your course. Community Boards turn
        passive lessons into engaging, collaborative spaces that boost
        completion and satisfaction.
      </Typography>
      <div className={classes.imageContainer}>
        <img
          src="/assets/editor-file/community/community.png"
          alt="Community Board Preview"
          className={classes.previewImage}
        />
      </div>
      <CoreButton
        color="primary"
        variant="contained"
        className={classes.button}
        onClick={() => {
          handleClickRedirect()
        }}
      >
        See Plans & Upgrade
      </CoreButton>
    </div>
  )
}

export default withStyles(styles)(CommunityFreeAccountModal)
